import React, { Component } from 'react'

class Message extends Component {
  
  render() {
    return (
      <div class="d-flex flex-column flex-root">
        <div class="login login-3 wizard d-flex flex-column flex-lg-row flex-column-fluid">
          <div class="login-content flex-row-fluid d-flex flex-column p-10">
            <div class="d-flex flex-row-fluid flex-center">
              <div class="login-form">
                <div class="pb-5 pb-lg-15">
                  <h4 class="text-muted font-weight-bold font-size-h4">Pivicon ID</h4>
                  <h3 class="font-weight-bolder text-dark font-size-h2 font-size-h1-lg">{this.props.headline}</h3>
                  <h4 class="text-muted font-weight-bold font-size-h4 mt-5">{this.props.message}</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default Message;